import './TaskDetailPanel.css';
import { faPlus, faTrash, faCheck } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect } from 'react';
import { Offcanvas, Form, Button, InputGroup, FormControl, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../../api/API';




const TaskDetailPanel = ({ show, onClose, task, projectId, reloadTasks }) => {
  const [descricao, setDescricao] = useState('');
  const [vencimento, setVencimento] = useState('');
  const [responsavel, setResponsavel] = useState('');
  const [subTarefas, setSubTarefas] = useState([]);
  const [novaSub, setNovaSub] = useState('');
  const [comentarios, setComentarios] = useState([]);
  const [novoComentario, setNovoComentario] = useState('');

  const [members, setMembers] = useState([]);
  const [tasks, setTasks] = useState([]);


  // 🔹 Quando abre, carrega dados da tarefa e subtarefas
  useEffect(() => {
    if (task) {
      setDescricao(task.descricao || '');
      setVencimento(task.vencimento ? new Date(task.vencimento).toISOString().split('T')[0] : '');
      setResponsavel(task.id_usuario_responsavel || '');
      fetchSubTarefas(task.id);
      fetchComentarios(task.id);
    }
  }, [task]);

  const fetchSubTarefas = async (id) => {
    try {
      const res = await api.get(`/tasks/subtasks/${id}`);
      setSubTarefas(res.data);
    } catch (e) {
      console.error('TaskDetailPanel: Erro ao buscar subtarefas:', e);
    }
  };

  const fetchMembers = async () => {
    try {
      const res = await api.get(`/projects/${projectId}/members`);
      setMembers(res.data);
    } catch (error) {
      console.error("Erro ao carregar membros", error);
    }
  }

  const fetchTasks = async () => {
    try {
      const res = api.get(`/projects/${projectId}/tasks`)
    } catch (error) {
      console.error("Erro ao carregar tarefas do projeto", error);
    }
  }

  const fetchComentarios = async (id) => {
    try {
      const res = await api.get(`/tasks/comments/${id}`);
      setComentarios(res.data);
    } catch (error) {
      console.error("TaskDetailPanel: Erro ao buscar comentários", error);

    }
  }

  const criarComentario = async () => {
    if (!novoComentario.trim()) return;

    try {
      await api.post(`/tasks/comments/${task.id}`, {
        fields: {comentario: novoComentario}
      });

      setNovoComentario('');
      fetchComentarios(task.id);

    } catch (e) {
      console.error('TaskDetailPanel: Erro ao criar comentário:', e);
    }
  };


  const salvarAlteracoes = async () => {
    try {
      await api.put(`/tasks/${task.id}`, {
        fields: { descricao, vencimento, id_usuario_responsavel: responsavel },
      });
      reloadTasks();
      onClose();
    } catch (e) {
      console.error('TaskDetailPanel: Erro ao atualizar tarefa:', e);
    }
  };

  const criarSubTarefa = async () => {
    if (!novaSub.trim()) return;
    try {
      await api.post('/tasks', {
        fields: {
          descricao: novaSub,
          id_projeto: projectId,
          id_tarefa: task.id,
          id_usuario_responsavel: responsavel,
          concluido: false,
          ativo: true,
        },
      });
      setNovaSub('');
      fetchSubTarefas(task.id);
    } catch (e) {
      console.error('TaskDetailPanel: Erro ao criar subtarefa:', e);
    }
  };

  const concluirSub = async (id) => {
    await api.put(`/tasks/${id}`, { fields: { concluido: true } });
    fetchSubTarefas(task.id);
  };

  const excluirSub = async (id) => {
    await api.delete(`/tasks/${id}`);
    fetchSubTarefas(task.id);
  };

  return (
    <Offcanvas show={show} onHide={onClose} placement="end" backdrop="static" scroll>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Editar Tarefa</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Título</Form.Label>
            <FormControl
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Digite a descrição da tarefa"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Data de Conclusão</Form.Label>
            <FormControl
              type="date"
              value={vencimento}
              onChange={(e) => setVencimento(e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" className="w-100 mb-3" onClick={salvarAlteracoes}>
            Salvar Alterações
          </Button>
        </Form>

        <hr />

        <h6>Sub-tarefas</h6>
        <InputGroup className="mb-3">
          <FormControl
            placeholder="Adicionar nova sub-tarefa..."
            value={novaSub}
            onChange={(e) => setNovaSub(e.target.value)}
            onKeyDown={(eventKey) => {
              if (eventKey === 'Enter') {
                eventKey.preventDefault();
                criarSubTarefa();
              }
            }}
          />
          <Button variant="outline-primary" onClick={criarSubTarefa}>
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </InputGroup>

        <ListGroup>
          {subTarefas.map((st) => (
            <ListGroup.Item
              key={st.id}
              className="d-flex justify-content-between align-items-center"
            >
              <span>{st.descricao}</span>
              <div>
                {!st.concluido && (
                  <Button
                    size="sm"
                    variant="success"
                    className="me-2"
                    onClick={() => concluirSub(st.id)}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </Button>
                )}
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => excluirSub(st.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>

        <hr />

        <h6>Comentários</h6>

        <InputGroup className="mb-3">
          <FormControl
            placeholder="Escreva um comentário..."
            value={novoComentario}
            onChange={(e) => setNovoComentario(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                criarComentario();
              }
            }}
          />
          <Button variant="primary" onClick={criarComentario}>
            Enviar
          </Button>
        </InputGroup>

        <ListGroup>
          {comentarios.map((c) => (
            <ListGroup.Item key={c.id}>
              <strong>{c.usuario}</strong>
              <div>{c.comentario}</div>
              <small className="text-muted">
                {new Date(c.criado_em).toLocaleString()}
              </small>
            </ListGroup.Item>
          ))}
        </ListGroup>



      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default TaskDetailPanel;
